import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: block;
    object-fit: contain;
  `,
} satisfies Styles<{ primaryColor?: string }>;

export const useStyles = withStyles(styles);
